export const ENV = {
  appName: 'litho-governance',
  dstChainID1: 109, // for polygon
  dstChainID2: 102, // for bsc
  requiredChainIds: {
    bsc: 56, // 97 for testnet
    polygon: 137, //80001 for testnet
  },
  choices: ["Approve", "Reject", "Abstain", "No with veto"],
  voteType: 'single-choice',
  votingStartIn: 5, //5 seconds
  votingEndIn: 60 * 60 * 24 * 365, // 600 days
  quorum: 100,
  vetoThreshold: 0.33,
  adminAddress: '0x878ca19a303Eb15875e0cf2b0d0914049EFE37dE',
  spaceName: 'lithodao.eth', // 'litho.eth' for testnet,
  snapshotUrl:'https://hub.snapshot.org', // 'https://testnet.hub.snapshot.org' for testnet,
  contractAddress: {
    bscGovernance: '0x868165c6C24dE147e7586BEc41A584C66C7Ce945',
    polygonGovernance: '0x0a3AFdc7e1107EE1c10F9e1379bB077E2F30b116',
    lithoToken: '0x61909950e1bfb5d567c5463cbd33dc1cdc85ee93', // LITHO token address on BSC
  },
  rpcProvider: "https://bsc-dataseed.binance.org", //'https://data-seed-prebsc-1-s1.binance.org:8545" for testnet
  amountToApprove: '1000000000000000000000',

  //return required keys
  getUserKeys: function (keys = null) {
    let userData = localStorage.getItem("encuse");
    if (userData) {
      return userData[keys];
    } else {
      return {};
    }
  },

  formattedAddress: (address) => {
    return `${address.slice(0, 5)}...${address.slice(-5)}`
  }
};

// https://bscscan.com/address/0x868165c6C24dE147e7586BEc41A584C66C7Ce945
// https://polygonscan.com/address/0x0a3AFdc7e1107EE1c10F9e1379bB077E2F30b116
